import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=5d89a960&scoped=true&"
import script from "./Documentation.vue?vue&type=script&lang=js&"
export * from "./Documentation.vue?vue&type=script&lang=js&"
import style0 from "./Documentation.vue?vue&type=style&index=0&id=5d89a960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89a960",
  null
  
)

component.options.__file = "Documentation.vue"
export default component.exports